<!--
 * @Author: nihuaifa
 * @Date: 2023-12-28 16:05:49
 * @LastEditors: nihuaifa
 * @LastEditTime: 2024-01-09 14:54:34
 * @Description: 请填写简介
-->
<template>
    <div class="stars" :class="{'fire-animate':starNum == 5 && animate}">
      <i :class="[ 'fa-star', { 'checked': starNum >= 1&& !animate ,'star-animate':starNum > 2 && animate}]" data-index="1" @click="rate"></i>
      <i :class="[ 'fa-star', { 'checked': starNum >= 2 && !animate,'star-animate':starNum > 2 && animate}]" data-index="2" @click="rate"></i>
      <i :class="[ 'fa-star', { 'checked': starNum >= 3 && !animate,'star-animate':starNum >= 3 && animate}]" data-index="3" @click="rate"></i>
      <i :class="[ 'fa-star', { 'checked': starNum >= 4 && !animate,'star-animate':starNum >= 4 && animate}]" data-index="4" @click="rate"></i>
      <i :class="[ 'fa-star', { 'checked': starNum >= 5 && !animate,'star-animate':starNum >= 5 && animate}]" data-index="5" @click="rate"></i>
      <img src="./img/star.png" style="display:none;opacity:0;" v-if="!readonly"/>
      <img src="./img/fireworks.png" style="display:none;opacity:0;" v-if="!readonly"/>
    </div>
  </template>
  
<script>
/**
 * icon,
    color,
   voidColor,
    count,
    voidIcon,
    disabled,
    disabledColor
 */
import create from '../create'
export default create({
        name: 'rate',
        props: {
            count: {
                type: Number,
                default: 5
            },
            value:0,
            readonly:Boolean
        },
        data() {
            return {
                starNum: 0,
                animate:false//默认没有星星绽放动效
            }
        },
        mounted() {
          this.starNum = this.value
        },
        methods: {
            rate(event) {
              const value = event.target.getAttribute('data-index')
              if(this.readonly||value==this.starNum)return
              this.$emit('input', value)
              this.$emit('change')
              this.animate=false
              setTimeout(()=>{
                this.starNum = value
                this.animate= value>=3
              })
            }
        }
    })
</script>
<style scoped lang="scss">
  .stars {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    height: 51px;
    width: 500px;
    &.fire-animate::before{
      content: '';
      background: url(./img/fireworks.png) 0 0 no-repeat;
      background-size: cover;
      display: inline-block;
      height: 150px;
      width: 100%;
      margin-left: -70px;
      pointer-events: none;
      animation: 2.3s fireWork  0.25s steps(77) none ;
    }
  }
  .fa-star {
    position: absolute;
    left: 0;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transform-origin:center ;
    &:nth-child(2){
      left: 84px;
    }
    &:nth-child(3){
      left: 168px;
    }
    &:nth-child(4){
      left: 252px;
    }
    &:nth-child(5){
      left: 336px;
    }
    &::before{
      content: '';
      background: url(./img/star_gray.png) no-repeat center center;
      background-size: cover;
      display: inline-block;
      width: 51px;
      height: 51px;
    }
  }
  .checked {
    &::before{
      background: url(./img/star_red.png) no-repeat center center;
      background-size: cover;
    }
  }
  .star-animate{
    // left: -30px;
    &::after{
      content: '';
      position: absolute;
      background: url(./img/star.png) 0 0 no-repeat;
      width: 111px;
      height: 111px;
      background-size: cover;
      display: inline-block;
    }
  }
.star-animate:nth-child(1)::after {
  animation: 0.65s  play 0s steps(22) forwards;
}

.star-animate:nth-child(2)::after {
   animation: 0.65s  play 0s steps(22) forwards;
}

.star-animate:nth-child(3)::after {
   animation: 0.65s  play 0s steps(22) forwards;
}

.star-animate:nth-child(4)::after {
   animation: 0.65s  play 0s steps(22) forwards;
}

.star-animate:nth-child(5)::after {
   animation: 0.65s  play  0s steps(22) forwards;
}

@keyframes play {
   from { background-position: 0%; }
   to { background-position: 100%; }
}
@keyframes fireWork {
   from { background-position: 0%; }
   to { background-position: 100%; }
}
  
  </style>